module.exports = __webpack_public_path__ + "img/upload-posterior-exotics.8e9be9ff.jpg";